import React, { useEffect, useRef, type ReactElement } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { AppointmentActionDialogsController } from "./appointment-action-dialogs";
import { ConnectedAppointmentActionDialogs } from "./connected-appointment-action-dialogs";
import { createWeekRefresher, type WeekRefresher } from "./week-action-mapping";
import { refreshAppointmentReads } from "./appointment-reads";

// NO-912. The appointment dialogs (New appointment, Reschedule, Edit note,
// Cancel or mark missed, Delete) mount here, at page level, so the header
// button works from every tab of My Appointments and not only from Week.

export function PageAppointmentDialogs(props: {
  controller: AppointmentActionDialogsController;
  rdId: string | null;
  timeZone: string;
  /** Reopens a visit's details panel when its dialog closes unchanged. */
  onBackToDetails?: (appointmentId: string) => void;
}): ReactElement {
  const queryClient = useQueryClient();
  const refresher = useRef<WeekRefresher | null>(null);

  refresher.current ??= createWeekRefresher(() => refreshAppointmentReads(queryClient));

  // Leaving the page must not leave reads waiting behind it.
  useEffect(() => () => refresher.current?.cancel(), []);

  return (
    <ConnectedAppointmentActionDialogs
      controller={props.controller}
      rdId={props.rdId}
      timeZone={props.timeZone}
      onChanged={() => refresher.current?.run()}
      onBackToDetails={props.onBackToDetails}
    />
  );
}
